import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import { SlideDown } from 'react-slidedown'
import config from 'config'
import format from '../../helpers/format'
import {
  Link,
  LinkIcon
} from '../../components'
import Styles from './PlanScorecardSourceData.css'

@CSSModules(Styles, {allowMultiple:true})
export default class PlanScorecardSourceData extends Component {
  static propTypes = {
    planId: PropTypes.string.isRequired,
    planData: PropTypes.object.isRequired,
    planOptions: PropTypes.object.isRequired
  }
  constructor(props) {
    super(props)
    this.state = {
      showSourceData: false,
      planId: props.planId,
      planData: props.planData,
      planOptions: props.planOptions
    }
  }

  render() {
    const { showSourceData, planId, planData, planOptions } = this.state
    //
    return (
      <div>
        <button
          styleName='section-slidedown-button'
          onClick={
            (e)=>{
              this.setState({
                showSourceData: !showSourceData
              })
            }
          }
        >
          <h2 styleName='section-slidedown-label'>
            Source data and methodology
          </h2>
          <div styleName='section-slidedown-icon'>
            <LinkIcon
              faclass={
                showSourceData ?
                  'fa-angle-up' :
                  'fa-angle-down'
              }
            />
          </div>
        </button>
        <SlideDown>
          {
            showSourceData ?
              (
                <div>
                  <button styleName='scorecard-methodology-link c'>
                    <Link
                      to={config.routes.howitworks}
                      title='How it works'
                      transparentbutton
                    >
                      Methodology<LinkIcon />
                    </Link>
                  </button>

                  <div styleName='sublede'>
                    The primary source data for the retirement plan
                    sustainability scorecards are <b>Form 5500 filings</b>.
                    These documents were downloaded from the <Link
                      to={config.links.dol5500search}
                      title='U.S. Department of Labor Form 5500 search'
                      xstrong
                    >U.S. Department of Labor Form 5500 search</Link>. If
                    further documentation from the company was available,
                    those documents are also included here.
                  </div>

                  { /* FILE LINKS (TODO: MOVE TO S3) */ }
                  <div styleName='sublede-bullets'>
                    {
                      planData.files && planData.files.length > 0 ?
                        (
                          <ul>
                            {
                              planData.files.map((e, i) => {
                                // e = [name, path]
                                return (
                                  <li>
                                    <Link
                                      to={'https://iyv-charts.s3.us-west-2.amazonaws.com/retirement-plans/' + planId + '/' + e[1]}
                                      xstrong
                                      targetBlank
                                      title={e[0]}
                                    >
                                      {e[0]}
                                      <LinkIcon faclass='fa-file-pdf-o' />
                                    </Link>
                                  </li>
                                )
                              })
                            }
                          </ul>
                        ) :
                        null
                      }
                  </div>
                  { /* FULL TABLE OF OPTIONS. RAW DATA */ }

                  <div styleName='plan-option-card'>
                    <div styleName='table-strong'>
                      Form 5500 source data
                    </div>
                    <div styleName='table-disclaimer'>
                      The table below represents the plan data that was used
                      to calculate the scorecard results, sourced from the
                      documents above.
                    </div>
                    <table styleName='full-row-table'>
                      <thead>
                        <tr styleName='dtls-tbl-row c'>
                          <th styleName='dtls-tbl-lbl'>
                            Plan option
                          </th>
                          <th styleName='dtls-tbl-val'>
                            Fund type
                          </th>
                          {
                            planData.allocations.default === 0 ?
                              null :
                              (
                                <th styleName='dtls-tbl-val'>
                                  USD$ invested by plan
                                </th>
                              )
                          }
                        </tr>
                      </thead>
                      <tbody>
                        { /* source data */
                          planOptions.all.map((e, i)=>{
                            console.log(e)
                            console.log(e.assets)
                            return (
                              <tr
                                styleName={'dtls-tbl-row'}
                                key={'dtls-tbl-row-'+i}
                              >
                                <td styleName='dtls-tbl-lbl'>
                                  {e.label}
                                </td>
                                <td styleName='dtls-tbl-val'>
                                  {e.fund_type}
                                </td>
                                {
                                  e.assets === 0 ?
                                    null :
                                    (
                                      <td styleName='dtls-tbl-val r'>
                                        {format.money(e.assets, false, 'USD', false, 0)}
                                      </td>
                                    )
                                }
                              </tr>
                            )
                          })
                        }
                      </tbody>
                    </table>
                  </div>
                  <br/>
                  <br/>
                </div>
              ) :
              null
          }
        </SlideDown>
      </div>
    )
  }
}